import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend, Tooltip } from "recharts";
import { DOMAIN_ORDER, domainPct, domainBand } from "@/lib/assessments";

export function BigFiveRadar({ pcts, ideal }) {
  const data = DOMAIN_ORDER.map(([k, label]) => ({
    trait: label, value: domainPct(pcts, k), idealMax: ideal[k]?.max ?? 0, idealMin: ideal[k]?.min ?? 0,
  }));
  return (
    <section className="panel space-y-2 p-5" data-testid="big-five-radar">
      <h3 className="text-base font-semibold">Big Five profile</h3>
      <p className="text-xs text-ink-muted">Percentiles against the norm group. The shaded band is this job's ideal range where one is set.</p>
      <ResponsiveContainer width="100%" initialDimension={{ width: 320, height: 280 }} height={290}>
        <RadarChart data={data} outerRadius="72%">
          <PolarGrid stroke="#E3DED3" />
          <PolarAngleAxis dataKey="trait" tick={{ fontSize: 11, fill: "#575B54" }} />
          <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
          <Radar name="Ideal range" dataKey="idealMax" stroke="#9A6700" strokeDasharray="4 3" fill="#F6EEDC" fillOpacity={0.7} isAnimationActive={false} />
          <Radar name=" " dataKey="idealMin" stroke="#9A6700" strokeDasharray="4 3" fill="#FFFFFF" fillOpacity={1} isAnimationActive={false} legendType="none" />
          <Radar name="Candidate" dataKey="value" stroke="#1F4D3A" strokeWidth={2} fill="#1F4D3A" fillOpacity={0.12} dot={{ r: 3, fill: "#1F4D3A" }} isAnimationActive={false} />
          <Tooltip formatter={(v, n) => (n === " " ? null : v)} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
        </RadarChart>
      </ResponsiveContainer>
      <ul className="grid grid-cols-2 gap-x-4 gap-y-1 text-xs sm:grid-cols-3" data-testid="domain-list">
        {DOMAIN_ORDER.map(([k, label]) => {
          const [lo, hi] = domainBand(pcts, k);
          return <li key={k} className="flex justify-between gap-2"><span className="text-ink-secondary">{label}</span><span className="tabular-nums text-ink">{domainPct(pcts, k)} <span className="text-ink-muted">({lo}–{hi})</span></span></li>;
        })}
      </ul>
    </section>
  );
}
